import api from '@/api'
import Cookies from 'js-cookie'

export default {
  state: () => ({
    depthHistory: [],
    homePage: {},
    navItems: [],
    navImage: {},
    pageContent: {},
    faqData: {},
    shipDetail: {},
    shipExperience: {},
    openPanel: false,
    isHideHeader: false,
    isHideFooter: false,
    countries: [],
    sessionKey: Cookies.get('session_key'),
    meta: {
      title: '皇家加勒比国际游轮官方网站-全新海洋光谱号 超越梦想新体验',
      description: '皇家加勒比国际游轮有限公司是全球著名游轮旅游服务公司,全球性豪华游轮品牌. 旗下豪华皇家船队包含:海洋光谱号、海洋量子号、海洋航行者号等豪华游轮.',
      keyword: '皇家加勒比,皇家加勒比国际游轮官网,皇家加勒比国际游轮,豪华游轮旅游,豪华游轮,海洋光谱号'
    },
    trackingCode: {},
    leftMenuIndex: -1,
    isMaskValue: true
  }),
  getters: {
    smsCallingCodes: state => {
      return state.countries.filter(r=>r.isAllowSendSms)
    }
  },
  actions: {
    HIDE_HEADER_BAR: ({
      commit
    }, {
      isHideHeader,
      isHideFooter
    }) => {
      commit('HIDE_HEADER_BAR', {
        isHideHeader,
        isHideFooter
      })
    },
    SET_NAV_PANEL: ({
      commit
    }, isOpen) => {
      commit('SET_NAV_PANEL', isOpen)
    },
    GET_HOME_PAGE: async ({
      commit
    }, { userName, cruiseId }) => {
      const {
        success,
        data,
        errMsg
      } = await api.page.GetHomePagePost({ userName, cruiseId })
      if (!success) {
        console.error(errMsg)
        return Promise.reject()
      }
      commit('SET_HOME_PAGE', {
        data
      })
    },
    GET_NAV_ITEMS: async ({
      commit
    }) => {
      const {
        success,
        data,
        errMsg
      } = await api.page.GetNavPost()
      if (!success) {
        console.error(errMsg)
        return Promise.reject()
      }
      if (data) {
        commit('GET_NAV_ITEMS', {
          data: data
        })
      }
    },
    GET_PAGE_CONTENT: async ({
      commit
    }, {
      url
    }) => {
      const {
        success,
        data,
        errMsg
      } = await api.page.getPageContent(url)
      if (!success) {
        console.error(errMsg)
        return Promise.reject()
      }
      if (data) {
        commit('GET_PAGE_CONTENT', {
          pageContent: data,
          url
        })
      }
    },
    SET_SESSION_KEY: ({
      commit
    }, sessionKey) => {
      commit('SET_SESSION_KEY', sessionKey)
    },
    SET_IS_MASK_VALUE: ({ commit }, isMaskValue) => {
      commit('SET_IS_MASK_VALUE', isMaskValue)
    },
    SET_COUNTRIES: async ({commit}) => {
      const { data } = await api.page.getCountries()
      if (data && data.length > 0) {
        commit('SET_COUNTRIES', data)
      }
    },
    GET_FAQ: async ({ commit }, requestData) => {
      const { data } = await api.page.getFaq(requestData)
      commit('GET_FAQ', data)
    },
    GET_SHIP_DETAIL: async( { commit }, shipCode) => {
      const { data } = await api.page.getShipDetail(shipCode)
      if (data && data.itemViewModel) commit('GET_SHIP_DETAIL', data)
    },
    GET_SHIP_EXPERIENCE: async( { commit }) => {
      const { data } = await api.page.getShipExperience()
      if (data && data.itemViewModel) commit('GET_SHIP_EXPERIENCE', data)
    },
  },
  mutations: {
    // 更新页面跳转路由记录
    UPDATE_DEPTH_HISTORY(state, payload) {
      const position = state.depthHistory.indexOf(payload)
      if (position > -1) {
        state.depthHistory.splice(position, 1)
      } else {
        state.depthHistory.push(payload)
      }
    },
    HIDE_HEADER_BAR: (state, {
      isHideHeader,
      isHideFooter
    }) => {
      state.isHideHeader = isHideHeader
      state.isHideFooter = isHideFooter
    },
    SET_NAV_PANEL: (state, isOpen) => {
      state.openPanel = isOpen
    },
    SET_HOME_PAGE: (state, {
      data
    }) => {
      if (data) {
        state.homePage = data
      }
    },
    GET_PAGE_CONTENT: (state, {
      pageContent,
      url
    }) => {
      if (pageContent && pageContent.body) {
        pageContent.url = url
        state.pageContent = pageContent
      }
    },
    GET_NAV_ITEMS: (state, {
      data
    }) => {
      if (data) {
        state.navItems = data.navs
        state.navImage = data.mobileImage
      }
    },
    SET_SESSION_KEY: (state, sessionKey) => {
      state.sessionKey = sessionKey
      Cookies.set('session_key', sessionKey)
    },
    SET_IS_MASK_VALUE: (state, isMaskValue) => {
      state.isMaskValue = isMaskValue
    },
    SET_COUNTRIES: (state, countries) => {
      state.countries = countries
    },
    SET_META: (state, { title, description, keyword }) => {
      state.meta = {
          title: title || '皇家加勒比国际游轮官方网站-全新海洋光谱号 超越梦想新体验',
          description: description || '皇家加勒比国际游轮有限公司是全球著名游轮旅游服务公司,全球性豪华游轮品牌. 旗下豪华皇家船队包含:海洋光谱号、海洋量子号、海洋航行者号等豪华游轮.',
          keyword: keyword || '皇家加勒比,皇家加勒比国际游轮官网,皇家加勒比国际游轮,豪华游轮旅游,豪华游轮,海洋光谱号'
      }
      try {
        document.getElementsByTagName('meta')["keywords"].content = keyword
        document.getElementsByTagName('meta')["description"].content = description
      } catch (error) {
        console.error(error)
      }
      
      if (title) document.title = title
    },
    GET_FAQ: (state, data) => {
      state.faqData = data
    },
    SET_FAQ_SUGGESTION (state, { faqId, type }) {
      const faqData = state.faqData
      if (faqData && faqData.itemViewModels) {
        const faq = faqData.itemViewModels.find(r=>r.id == faqId)
        if (faq) {
          faq.suggestionType=type
        }
      }
      
    },
    GET_SHIP_DETAIL: (state, data) => {
      state.shipDetail = data
    },
    GET_SHIP_EXPERIENCE: (state, data) => {
      state.shipExperience = data
    },
    SET_LEFT_MENU: (state, data) => {
      if (!isNaN(parseInt(data+''))) {
        state.leftMenuIndex = data
      }
    }
  }
}